import { useEffect } from 'react';
import { useDiagramStore } from './diagram-store.hook';

export const useSendOp = () => {
  const sendOperations = useDiagramStore((state) => state.sendOperations);
  const outbox = useDiagramStore((state) => state.outbox);
  const id = useDiagramStore((state) => state.data?.id);

  useEffect(() => {
    if (outbox.size === 0 || !id) return;
    const interval = setInterval(() => {
      void sendOperations();
    }, 100);
    return () => clearInterval(interval);
  }, [outbox.size, sendOperations, id]);
};
